import { styled as muiStyled } from '@mui/material/styles';
import { Stack, TableCell, alpha } from '@mui/material';
import { abyssColors } from '../../../../theme/colors';

export const StyledTableCell = muiStyled(TableCell)(() => ({
  width: '9.5%',
  padding: '0.5rem 16px',
  display: 'flex',
  alignItems: 'center',
  borderBottom: 'none',
}));

export const DisabledOverlay = muiStyled(Stack)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: alpha(abyssColors.primary[50], 0.9),
  zIndex: 10,
  alignItems: 'center',
  justifyContent: 'center',
}));
